export default {
	name: 'end',
	description: 'Окно завершения игры',
	title: 'Подведение итогов',
	minigameType: 'End',
	generateParams(minigame, state) {
		return { history: state.objects.history };
	},
    messages() {
		return {
			onStart: 'Вы ответили на все вопросы, имеющиеся в текущей версии игры. Переходим к подведению итогов.',
		};
	},
	isCompleted: () => true,
	score: 0,
};